import React from 'react'
import Product from '../../components/Product/Product'
import CarouselEffect from "../../components/Carousel/CarouselEffect"
import Category from "../../components/Category/Categoryy"
import Layout from '../../components/Layout/Layoutt'
function Landingg() {
  return (
    <Layout>
      <CarouselEffect/>
      <Category/>
      <Product/>
    </Layout>
  )
}

export default Landingg;
